import { IDepartment } from '../../../shared/interfaces/department/IDepartment';
import { IBaseModel } from '../../../shared/interfaces/shared/IBase';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { requests } from '../../../utils/api/api.service';
import { DEPARTMENT_URL } from '../../../utils/api/endpoints';

export const AdminDepartmentService = {
  get: (pagination: IPagination): Promise<IBaseModel<IDepartment[]>> =>
    requests.get(DEPARTMENT_URL, pagination),
  getSingle: (id: number): Promise<IDepartment> =>
    requests.get(`${DEPARTMENT_URL}/${id}`),
  create: (params: IDepartment) => requests.post(DEPARTMENT_URL, params),
  update: (params: IDepartment, id: number): Promise<IDepartment> =>
    requests.put(`${DEPARTMENT_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${DEPARTMENT_URL}/${id}`),
  deleteUser: (departmentId: number, userId: number) =>
    requests.delete(`${DEPARTMENT_URL}/${departmentId}/${userId}`),
};
